import { t, useLocale } from '../localization/adminText';
import { Badge, BlockStack, Text, Tooltip } from './admin-ui';
import { riskScore, riskScoreTone } from '../utils/riskScore';

export default function RiskScoreBadge({ order }) {
  useLocale();
  if ((order.type || order.order_type) === 'online' || order.risk_level === 'not_applicable') return <Badge tone="info">{t('Online')}</Badge>;
  const score = riskScore(order);
  const history = order.risk_assessment?.history_score;
  const description = score === null ? t('Risk score unavailable') : t('The score combines ordering behavior and confirmed refusal history, not a refusal probability.');
  return <BlockStack gap="100">
    <Tooltip content={description}><span aria-label={score === null ? description : t('Risk score: {0}', [score])}>
      <Badge tone={riskScoreTone(score)}>{score ?? '—'}</Badge>
    </span></Tooltip>
    {score !== null && history?.score > 0 && <Text as="p" tone="subdued">{t('Behavior +{0} · History +{1}', [order.risk_assessment.behavior_score, history.score])}</Text>}
  </BlockStack>;
}
